const translateStatus = (status: number | null): string => {
    if (status === null) return 'Sin datos';
    if (status === 2) return 'En proceso';

    if (typeof status === 'number') {
        if (status <= -1) return 'Retroceso';
        if (status === 0) return 'Sin cambios';
        if (status >= 1) return 'Mejora';
    }

    return '';
};

const EvaluationStates = ({
    status,
    evaluationStateStyleText
}: {
    status: number | null,
    evaluationStateStyleText: string
}) => {
    const getStatusClass = (status: number | null): string => {
        if (status === null) return 'text-gray-60';
        if (typeof status === 'number') {
            if (status === 2) return 'text-gray-60'; //En proceso
            if (status > 0) return 'text-indicator-green'; // Mejora
            if (status === 0) return 'text-indicator-yellow'; // Sin cambios
            if (status < 0) return 'text-indicator-red'; // Retroceso
        }
        return 'text-gray-60';
    };

    return (
        <span className={`${getStatusClass(status)} ${evaluationStateStyleText}`}>
            {translateStatus(status)}
        </span>
    );
};

export default EvaluationStates